var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68359 0L5.92045 -1.17242e-07L5.92045 0.394709C5.92045 1.27143 5.21816 1.97372 4.34143 1.97372C3.46471 1.97372 2.76242 1.27143 2.76242 0.394709L2.76242 -2.51239e-07L-0.000723839 -3.68481e-07L-0.000724585 16.5793L2.76242 16.5793L2.76242 16.1846C2.76242 15.3079 3.46471 14.6056 4.34143 14.6056C5.21816 14.6056 5.92045 15.3079 5.92045 16.1846L5.92045 16.5793L8.68359 16.5793L8.68359 0ZM7.89417 0.789419L7.89417 11.4475L7.10475 11.4475L7.10475 12.2369L7.89417 12.2369L7.89417 15.7897L6.62976 15.7897C6.43398 14.6805 5.5048 13.8159 4.34143 13.8159C3.17778 13.8159 2.24862 14.6802 2.05311 15.7897L0.788695 15.7897L0.788695 12.2369L1.57811 12.2369L1.57811 11.4475L0.788695 11.4475L0.788696 0.789419L2.05311 0.789419C2.24861 1.89883 3.17778 2.76314 4.34143 2.76314C5.5048 2.76314 6.43397 1.89855 6.62976 0.789419L7.89417 0.789419ZM6.31516 11.4475L4.73614 11.4475L4.73614 12.2369L6.31516 12.2369L6.31516 11.4475ZM3.94672 11.4475L2.36771 11.4475L2.36771 12.2369L3.94672 12.2369L3.94672 11.4475Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.74dc25fe1970ba9283eff9ff90f2fbc4.svg";
export { ForwardRef as ReactComponent };